var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('form-checkbox-basic'),_c('form-checkbox-custom'),_c('form-checkbox-color'),_c('form-checkbox-multiple'),_c('form-checkbox-change-names'),_c('form-checkbox-stacked-inline'),_c('form-checkbox-states'),_c('form-checkbox-indeterminate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }